import { getDealsArticleConfig } from '../getDealsArticleConfig';
import { getDealsBannerText } from '../getDealsBannerText';
import type { IDealsBannerText, TDealsBannerConfig } from '../../types/dealsBannerConfig';
import type { IDealsArticleConfig, TDealsContentConfig } from '../../types/dealsContentConfig';

/**
 * Тексты виджетов Сделки для статьи: форма из dealsContentConfig,
 * баннер из dealsBannerConfig. RS-ключи остаются раздельными.
 */
export interface IDealsWidgetsConfig {
  form?: IDealsArticleConfig;
  banner?: IDealsBannerText;
}

export const getDealsWidgetsConfig = (
  postId: number,
  dealsContentConfig: TDealsContentConfig | null,
  dealsBannerConfig: TDealsBannerConfig | null,
): IDealsWidgetsConfig => ({
  form: getDealsArticleConfig(postId, dealsContentConfig),
  banner: getDealsBannerText(postId, dealsBannerConfig),
});
